import { render, staticRenderFns } from "./CDemo.vue?vue&type=template&id=83b7dc46&"
import script from "./CDemo.vue?vue&type=script&lang=js&"
export * from "./CDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports